module.exports = __webpack_public_path__ + "img/sz.b6570643.svg";